import { Button, Modal } from "antd";
import { useState } from "react";
import "./CreateFolderModal.scss";
import LocationsApi from "../../api/LocationsApi";
import { MenuFolderDto } from "../../generated/dashboard-client";

export interface DeleteFolderModalProps {
  folder: MenuFolderDto | null;
  isVisible: boolean;
  onClose: (removed: number) => void;
}

export function DeleteFolderModal({
  folder,
  isVisible,
  onClose,
}: DeleteFolderModalProps) {
  const [saving, setSaving] = useState(false);

  function remove() {
    setSaving(true);
    LocationsApi.deleteFolder(folder?.id!)
      .then(() => {
        onClose(folder?.id!);
        setSaving(false);
      })
      .catch(() => {
        setSaving(false);
      });
  }

  return (
    <Modal
      className={"create-folder-modal clean"}
      visible={isVisible}
      onCancel={() => onClose(0)}
    >
      <header>
        <h2>Delete {folder?.name}?</h2>
      </header>

      <p>
        Designs will not be deleted. <br />
        All your designs are stored in the Saved Designs tab.
      </p>

      <footer>
        <Button size={"large"} onClick={() => onClose(0)}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={remove}
          loading={saving}
        >
          Delete Folder
        </Button>
      </footer>
    </Modal>
  );
}
